import { forBrand, environment, Configurable } from "@crystal/config";
import { Touchpoint } from "./touchpoints.js";
const registrationSourceIds = forBrand({
  adidas: environment({
    default: {
      [Touchpoint.Unknown]: "6000000415",
      [Touchpoint.Header]: "6000000381",
      [Touchpoint.Footer]: "6000000409",
      [Touchpoint.ProfileIcon]: "6000000410",
      [Touchpoint.Wishlist]: "6000000411",
      [Touchpoint.WishlistPage]: "6000001120",
      [Touchpoint.FreeDeliveryPdp]: "6000000412",
      [Touchpoint.OrderTracker]: "6000000413",
      [Touchpoint.BehaviouralOverlay]: "6000000416",
      [Touchpoint.ConfirmedWeb]: "6000001067",
      [Touchpoint.RegistrationPage]: "40",
      [Touchpoint.LoginPage]: "40",
      [Touchpoint.CtaRegistration]: "6000001079",
      [Touchpoint.MembersExclusivePdp]: "40",
      [Touchpoint.AdidasRunners]: "543452149",
      [Touchpoint.InviteAFriend]: "543453261",
      [Touchpoint.InviteAFriendSenderPage]: "6000001114",
      [Touchpoint.Raffles]: "6000001102",
      [Touchpoint.MembershipBarrierPlp]: "6000001104",
      [Touchpoint.VoucherModal]: "6000001105",
      [Touchpoint.MinicartOverlay]: "6000001074",
      [Touchpoint.EarlyAccessPdp]: "6000001107",
      [Touchpoint.MembershipBarrierPdp]: "6000001106",
      [Touchpoint.MembersExclusivePlp]: "6000001110",
      [Touchpoint.MemberPricing]: "6000001109",
      [Touchpoint.Connect]: "6000001119",
      [Touchpoint.ConnectedProduct]: "6000001122",
      [Touchpoint.Campaign]: "6000001123",
      [Touchpoint.GET]: "6000001124",
      [Touchpoint.CalendarReminder]: "6000001125",
      [Touchpoint.Waitlist]: "6000001126",
      [Touchpoint.ConfirmedApp]: "-dynamic-",
      [Touchpoint.APUniversal]: "-dynamic-",
      [Touchpoint.AdidasApp]: "-dynamic-",
      [Touchpoint.Checkout]: "6000001138",
      [Touchpoint.Cart]: "6000001138",
      [Touchpoint.PartnerLinking]: "6000001161",
      [Touchpoint.AdidasRunningWeb]: "543453136",
      [Touchpoint.AdidasRunningApp]: "-dynamic-",
      [Touchpoint.SidePanelGuestMode]: "6000001169"
    },
    production: {
      [Touchpoint.Unknown]: "6000001051",
      [Touchpoint.Header]: "6000000790",
      [Touchpoint.Footer]: "6000001046",
      [Touchpoint.ProfileIcon]: "6000001047",
      [Touchpoint.Wishlist]: "6000001048",
      [Touchpoint.WishlistPage]: "6000001499",
      [Touchpoint.FreeDeliveryPdp]: "6000001049",
      [Touchpoint.OrderTracker]: "6000001050",
      [Touchpoint.BehaviouralOverlay]: "6000001054",
      [Touchpoint.ConfirmedWeb]: "6000001097",
      [Touchpoint.RegistrationPage]: "40",
      [Touchpoint.LoginPage]: "40",
      [Touchpoint.CtaRegistration]: "6000001136",
      [Touchpoint.MembersExclusivePdp]: "40",
      [Touchpoint.AdidasRunners]: "543453025",
      [Touchpoint.InviteAFriend]: "543462642",
      [Touchpoint.InviteAFriendSenderPage]: "6000001485",
      [Touchpoint.Raffles]: "6000001428",
      [Touchpoint.MembershipBarrierPlp]: "6000001449",
      [Touchpoint.VoucherModal]: "6000001450",
      [Touchpoint.MinicartOverlay]: "6000001116",
      [Touchpoint.EarlyAccessPdp]: "6000001452",
      [Touchpoint.MembershipBarrierPdp]: "6000001451",
      [Touchpoint.MembersExclusivePlp]: "6000001457",
      [Touchpoint.MemberPricing]: "6000001454",
      [Touchpoint.Connect]: "6000001480",
      [Touchpoint.ConnectedProduct]: "6000001511",
      [Touchpoint.Campaign]: "6000001512",
      [Touchpoint.GET]: "6000001513",
      [Touchpoint.CalendarReminder]: "6000001529",
      [Touchpoint.Waitlist]: "6000001530",
      [Touchpoint.ConfirmedApp]: "-dynamic-",
      [Touchpoint.APUniversal]: "-dynamic-",
      [Touchpoint.AdidasApp]: "-dynamic-",
      [Touchpoint.Checkout]: "6000001632",
      [Touchpoint.Cart]: "6000001632",
      [Touchpoint.PartnerLinking]: "6000001890",
      [Touchpoint.AdidasRunningWeb]: "543462213",
      [Touchpoint.AdidasRunningApp]: "-dynamic-",
      [Touchpoint.SidePanelGuestMode]: "6000001950"
    }
  }),
  reebok: {
    [Touchpoint.Unknown]: "285",
    [Touchpoint.Header]: "285",
    [Touchpoint.Footer]: "285",
    [Touchpoint.ProfileIcon]: "285",
    [Touchpoint.Wishlist]: "285",
    [Touchpoint.WishlistPage]: "285",
    [Touchpoint.FreeDeliveryPdp]: "285",
    [Touchpoint.OrderTracker]: "285",
    [Touchpoint.BehaviouralOverlay]: "285",
    [Touchpoint.ConfirmedWeb]: "285",
    [Touchpoint.RegistrationPage]: "285",
    [Touchpoint.LoginPage]: "285",
    [Touchpoint.CtaRegistration]: "285",
    [Touchpoint.MembersExclusivePdp]: "285",
    [Touchpoint.AdidasRunners]: "285",
    [Touchpoint.Raffles]: "285",
    [Touchpoint.MembershipBarrierPlp]: "285",
    [Touchpoint.VoucherModal]: "285",
    [Touchpoint.InviteAFriend]: "285",
    [Touchpoint.InviteAFriendSenderPage]: "285",
    [Touchpoint.MinicartOverlay]: "285",
    [Touchpoint.EarlyAccessPdp]: "285",
    [Touchpoint.MembershipBarrierPdp]: "285",
    [Touchpoint.MembersExclusivePlp]: "285",
    [Touchpoint.MemberPricing]: "285",
    [Touchpoint.Connect]: "285",
    [Touchpoint.ConnectedProduct]: "285",
    [Touchpoint.Campaign]: "285",
    [Touchpoint.GET]: "285",
    [Touchpoint.CalendarReminder]: "285",
    [Touchpoint.Waitlist]: "285",
    [Touchpoint.ConfirmedApp]: "-dynamic-",
    [Touchpoint.APUniversal]: "-dynamic-",
    [Touchpoint.AdidasApp]: "-dynamic-",
    [Touchpoint.Checkout]: "285",
    [Touchpoint.Cart]: "285",
    [Touchpoint.PartnerLinking]: "285",
    [Touchpoint.AdidasRunningWeb]: "285",
    [Touchpoint.AdidasRunningApp]: "-dynamic-",
    [Touchpoint.SidePanelGuestMode]: "285"
  }
});
const activationSourceIds = forBrand({
  adidas: environment({
    default: {
      [Touchpoint.Unknown]: "6000000415",
      [Touchpoint.Header]: "6000000382",
      [Touchpoint.Footer]: "6000000382",
      [Touchpoint.ProfileIcon]: "6000000382",
      [Touchpoint.Wishlist]: "6000000382",
      [Touchpoint.WishlistPage]: "6000000382",
      [Touchpoint.FreeDeliveryPdp]: "6000000382",
      [Touchpoint.OrderTracker]: "6000000382",
      [Touchpoint.BehaviouralOverlay]: "6000000382",
      [Touchpoint.ConfirmedWeb]: "6000000382",
      [Touchpoint.RegistrationPage]: "6000000382",
      [Touchpoint.LoginPage]: "6000000382",
      [Touchpoint.CtaRegistration]: "6000000382",
      [Touchpoint.MembersExclusivePdp]: "6000000382",
      [Touchpoint.AdidasRunners]: "6000000382",
      [Touchpoint.Raffles]: "6000000382",
      [Touchpoint.MembershipBarrierPlp]: "6000000382",
      [Touchpoint.VoucherModal]: "6000000382",
      [Touchpoint.MinicartOverlay]: "6000000382",
      [Touchpoint.EarlyAccessPdp]: "6000000382",
      [Touchpoint.MembershipBarrierPdp]: "6000000382",
      [Touchpoint.MembersExclusivePlp]: "6000000382",
      [Touchpoint.MemberPricing]: "6000000382",
      [Touchpoint.InviteAFriend]: "6000000382",
      [Touchpoint.InviteAFriendSenderPage]: "6000000382",
      [Touchpoint.Connect]: "6000000382",
      [Touchpoint.ConnectedProduct]: "6000000382",
      [Touchpoint.Campaign]: "6000000382",
      [Touchpoint.GET]: "6000000382",
      [Touchpoint.CalendarReminder]: "6000000382",
      [Touchpoint.Waitlist]: "6000000382",
      [Touchpoint.ConfirmedApp]: "-dynamic-",
      [Touchpoint.APUniversal]: "-dynamic-",
      [Touchpoint.AdidasApp]: "-dynamic-",
      [Touchpoint.Checkout]: "6000000382",
      [Touchpoint.Cart]: "6000000382",
      [Touchpoint.PartnerLinking]: "6000000382",
      [Touchpoint.AdidasRunningWeb]: "6000000382",
      [Touchpoint.AdidasRunningApp]: "-dynamic-",
      [Touchpoint.SidePanelGuestMode]: "6000000382"
    },
    production: {
      [Touchpoint.Unknown]: "6000001051",
      [Touchpoint.Header]: "6000000791",
      [Touchpoint.Footer]: "6000000791",
      [Touchpoint.ProfileIcon]: "6000000791",
      [Touchpoint.Wishlist]: "6000000791",
      [Touchpoint.WishlistPage]: "6000000791",
      [Touchpoint.FreeDeliveryPdp]: "6000000791",
      [Touchpoint.OrderTracker]: "6000000791",
      [Touchpoint.BehaviouralOverlay]: "6000000791",
      [Touchpoint.ConfirmedWeb]: "6000000791",
      [Touchpoint.RegistrationPage]: "6000000791",
      [Touchpoint.LoginPage]: "6000000791",
      [Touchpoint.CtaRegistration]: "6000000791",
      [Touchpoint.MembersExclusivePdp]: "6000000791",
      [Touchpoint.Raffles]: "6000000791",
      [Touchpoint.MembershipBarrierPlp]: "6000000791",
      [Touchpoint.VoucherModal]: "6000000791",
      [Touchpoint.MinicartOverlay]: "6000000791",
      [Touchpoint.EarlyAccessPdp]: "6000000791",
      [Touchpoint.MembershipBarrierPdp]: "6000000791",
      [Touchpoint.MembersExclusivePlp]: "6000000791",
      [Touchpoint.MemberPricing]: "6000000791",
      [Touchpoint.AdidasRunners]: "6000000791",
      [Touchpoint.InviteAFriend]: "6000000791",
      [Touchpoint.InviteAFriendSenderPage]: "6000000791",
      [Touchpoint.Connect]: "6000000791",
      [Touchpoint.ConnectedProduct]: "6000000791",
      [Touchpoint.Campaign]: "6000000791",
      [Touchpoint.GET]: "6000000791",
      [Touchpoint.CalendarReminder]: "6000000791",
      [Touchpoint.Waitlist]: "6000000791",
      [Touchpoint.ConfirmedApp]: "-dynamic-",
      [Touchpoint.APUniversal]: "-dynamic-",
      [Touchpoint.AdidasApp]: "-dynamic-",
      [Touchpoint.Checkout]: "6000000791",
      [Touchpoint.Cart]: "6000000791",
      [Touchpoint.PartnerLinking]: "6000000791",
      [Touchpoint.AdidasRunningWeb]: "6000000791",
      [Touchpoint.AdidasRunningApp]: "-dynamic-",
      [Touchpoint.SidePanelGuestMode]: "6000000791"
    }
  }),
  reebok: {
    [Touchpoint.Unknown]: "6000000100",
    [Touchpoint.Header]: "6000000100",
    [Touchpoint.Footer]: "6000000100",
    [Touchpoint.ProfileIcon]: "6000000100",
    [Touchpoint.Wishlist]: "6000000100",
    [Touchpoint.WishlistPage]: "6000000100",
    [Touchpoint.FreeDeliveryPdp]: "6000000100",
    [Touchpoint.OrderTracker]: "6000000100",
    [Touchpoint.BehaviouralOverlay]: "6000000100",
    [Touchpoint.ConfirmedWeb]: "6000000100",
    [Touchpoint.RegistrationPage]: "6000000100",
    [Touchpoint.LoginPage]: "6000000100",
    [Touchpoint.CtaRegistration]: "6000000100",
    [Touchpoint.Raffles]: "6000000100",
    [Touchpoint.MembershipBarrierPlp]: "6000000100",
    [Touchpoint.VoucherModal]: "6000000100",
    [Touchpoint.MinicartOverlay]: "6000000100",
    [Touchpoint.EarlyAccessPdp]: "6000000100",
    [Touchpoint.MembershipBarrierPdp]: "6000000100",
    [Touchpoint.MemberPricing]: "6000000100",
    [Touchpoint.MembersExclusivePdp]: "285",
    [Touchpoint.AdidasRunners]: "6000000100",
    [Touchpoint.InviteAFriend]: "6000000100",
    [Touchpoint.InviteAFriendSenderPage]: "6000000100",
    [Touchpoint.MembersExclusivePlp]: "6000000100",
    [Touchpoint.Connect]: "6000000100",
    [Touchpoint.ConnectedProduct]: "6000000100",
    [Touchpoint.Campaign]: "6000000100",
    [Touchpoint.GET]: "6000000100",
    [Touchpoint.CalendarReminder]: "6000000100",
    [Touchpoint.Waitlist]: "6000000100",
    [Touchpoint.ConfirmedApp]: "-dynamic-",
    [Touchpoint.APUniversal]: "-dynamic-",
    [Touchpoint.AdidasApp]: "-dynamic-",
    [Touchpoint.Checkout]: "6000000100",
    [Touchpoint.Cart]: "6000000100",
    [Touchpoint.PartnerLinking]: "6000000100",
    [Touchpoint.AdidasRunningWeb]: "6000000100",
    [Touchpoint.AdidasRunningApp]: "-dynamic-",
    [Touchpoint.SidePanelGuestMode]: "6000000100"
  }
});
const sourceIds = Configurable.props({ registrationSourceIds, activationSourceIds });
export {
  sourceIds
};
//# sourceMappingURL=source-ids.js.map
